<template>
  <div>
    <iModal :title="modelTitle" v-model="showModal" class-name="vertical-center-modal" width="500px" :mask-closable="false" @on-cancel="cancel">
      <div class="admin-add">
        <div class="admin-add-content">
          <Form ref="formInline" :model="formInline" :rules="ruleInline" label-position="right" :label-width="100" @submit.native.prevent>
            <FormItem label="提示类型：" prop="finishtype">
              <Select v-model="formInline.finishtype">
                <Option v-for="item in typesList" :value="item.id" :key="item.id">{{item.description}}</Option>
              </Select>
            </FormItem>
            <FormItem label="标题：" prop="title">
              <Input v-model="formInline.title" />
            </FormItem>
            <FormItem label="英文标题：" prop="titleEn">
              <Input v-model="formInline.titleEn" />
            </FormItem>
            <FormItem label="说明：" prop="introduction">
              <Input v-model="formInline.introduction" type="textarea" :rows="4" />
            </FormItem>
            <FormItem label="英文说明：" prop="introductionEn">
              <Input v-model="formInline.introductionEn" type="textarea" :rows="4" />
            </FormItem>
            <Row>
              <Col span="12">
              <FormItem label="截止时间：" prop="time" :rules="!Istime ? [{ required: true, type: 'date',message: '必填选项', trigger: 'blur'},] : [{ required: false,}]">
                <DatePicker type="date" placeholder="截止时间" style="width: 200px" v-model="formInline.time"></DatePicker>
              </FormItem>
              </Col>
              <Col span="12">
              <FormItem>
                <Checkbox v-model="Istime">无截止时间</Checkbox>
              </FormItem>
              </Col>
            </Row>
            <FormItem label="链接地址：" prop="url">
              <Input v-model="formInline.url" />
            </FormItem>
            <FormItem label="排序：" prop="showIndex">
              <InputNumber :max="99999999" :min="-10" v-model="formInline.showIndex"></InputNumber>
              <p style="font-size:12px;">(数字越小显示越靠前)</p>
            </FormItem>
          </Form>
        </div>
      </div>
      <div slot="footer">
        <Button type="primary" :loading="loading" @click="handleSubmit('formInline')">确定</Button>
        <Button @click="cancel">取消</Button>
      </div>
    </iModal>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import { validator } from "@/other/validator";
let moment = require("moment");

export default {
  name: "classify-add",
  props: {
    show: {
      type: Boolean,
      default: false
    },
    modelTitle: {
      type: String,
    },
    options: {
      type: Object
    },
  },
  data () {
    return {
      loading: false,
      showModal: false,
      time: [],
      typesList: [],
      Istime: '',
      editId: '',
      formInline: {
        // form双向绑定
        finishtype: '',
        title: "",
        titleEn: "",
        introduction: "",
        introductionEn: "",
        time: '',
        url: '',
        showIndex: 0
      },
      color: "#000",
      ruleInline: {
        finishtype: [{ required: true, type: 'number', message: "必填选项", trigger: "blur" }],
        title: [{ required: true, message: "必填选项", trigger: "blur" }],
        titleEn: [{ required: true, message: "必填选项", trigger: "blur" }],
        introduction: [{ required: true, message: "必填选项", trigger: "blur" }],
        introductionEn: [{ required: true, message: "必填选项", trigger: "blur" }],
        url: [
          ...validator.Website
        ],
      }
    };
  },
  computed: {
    exhibitionInfo () {
      if (JSON.parse(localStorage.vuex)) {
        return JSON.parse(localStorage.vuex).hostSetModule.hostExhibition;
      }
    },
    header () { return this.$store.state.header },
  },
  watch: {
    show (val, oldVal) {
      this.showModal = val;
      if (!val) this.$emit("close");
    },
    options (val) {
      if (val.msg) {
        this.formInline.finishtype = val.msg.finishType;
        this.formInline.title = val.msg.name;
        this.formInline.titleEn = val.msg.nameEn;
        this.formInline.introduction = val.msg.introduction;
        this.formInline.introductionEn = val.msg.introductionEn;
        this.formInline.showIndex = val.msg.showIndex;
        this.formInline.url = val.msg.link;
        this.formInline.time = val.msg.stopTime;
        this.editId = val.msg.id;
        if (!val.msg.stopTime) {
          this.Istime = true;
        }
      }
    }
  },
  created () { this.getTypes(); },
  methods: {
    ...mapActions({
      addKind: "categoryModule/addKind"
    }),
    getTypes () {
      this.$http.get('/api/FinishItem/GetTypes2', this.header)
        .then(res => {
          if (res.status === 200 && res.data) {
            this.typesList = res.data;
            console.log(this.typesList, 'this.typesList')
          }
        })
    },
    async handleSubmit (name) {
      let form = this.formInline;
      let valid = await this.validForm(name);
      if (!valid) return;

      // 编辑模式
      if (this.options.model) {
        this.editPro(form);
      } else { // 新增模式
        this.addPro(form);
      }
    },
    addPro (form) {
      let time = "";
      if (!this.Istime) {
        time = moment(this.formInline.time).format("YYYY-MM-DD");
      }
      let body = {
        "exhibitionId": this.exhibitionInfo.id,
        "finishType": form.finishtype,
        "name": form.title,
        "nameEn": form.titleEn,
        "introduction": form.introduction,
        "introductionEn": form.introductionEn,
        "showIndex": form.showIndex,
        "link": form.url,
        "stopTime": time,
      }
      this.$http.post('/api/FinishItem', body, this.header)
        .then(res => {
          if (res.status === 200 && res.data.successed) {
            this.loading = false;
            this.$Message.success("添加成功！");
            this.cancel();
            this.$emit('finish')
          } else {
            this.loading = false;
            this.$Message.error("添加失败，请重新尝试");
          }
        })
    },
    editPro (form) {
      let time = "";
      if (!this.Istime) {
        time = moment(this.formInline.time).format("YYYY-MM-DD");
      }
      let body = {
        "Id": this.editId,
        "SetValues": {
          "ExhibitionId": this.exhibitionInfo.id,
          "FinishType": form.finishtype,
          "Name": form.title,
          "NameEn": form.titleEn,
          "Introduction": form.introduction,
          "IntroductionEn": form.introductionEn,
          "ShowIndex": form.showIndex,
          "Link": form.url,
          "StopTime": time,
        }
      }
      this.$http.put('/api/FinishItem', body, this.header)
        .then(res => {
          if (res.status === 200 && res.data.successed) {
            this.loading = false;
            this.$Message.success("修改成功！");
            this.cancel();
            this.$emit('finish');
          } else {
            this.loading = false;
            this.$Message.error("修改失败，请重新尝试");
          }
        })
    },
    validForm (name) {
      // 验证表单
      return new Promise((resolve, reject) => {
        this.$refs[name].validate(valid => {
          resolve(valid);
        });
      });
    },
    cancel () {
      this.$refs["formInline"].resetFields();
      this.$emit("close");
      this.formInline = {
        finishtype: '',
        title: "",
        introduction: "",
        time: '',
        url: '',
        showIndex: 0
      };
      this.editId = '';
      this.Istime = false;
    },
  }
};
</script>

<style scoped lang="scss">
.admin-add {
  &-content {
    padding: 20px 40px 20px 20px;
  }
}
.admin-add {
  &-title {
    width: 100%;
    text-align: center;
    margin-bottom: 20px;
    font-size: 16px;
  }
  &-content {
    .submit {
      display: flex;
      justify-content: center;
      button {
        margin-left: -75px;
      }
    }
    img {
      width: 150px;
      height: 150px;
    }
  }
  .form-code-item {
    position: relative;
    .form-code-btn {
      position: absolute;
      right: 1px;
      width: 96px;
      top: 2px;
      border: none;
      outline: none;
      &:focus {
        box-shadow: none;
        border: none;
        outline: none;
      }
    }
  }
}
</style>

